import { Component, inject, OnInit, signal } from '@angular/core';
import { PaymentWebhookService } from '../../../../services/setting/webhooks/payment-webhook-service';
import { PaymentWebhook } from '../../../../models/payment-webhook';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { AddPaymentWebhookForm } from '../../../../@shared/forms/setting/webhooks/payment/add-payment-webhook-form/add-payment-webhook-form';
import { DeletePaymentWebhookForm } from '../../../../@shared/forms/setting/webhooks/payment/delete-payment-webhook-form/delete-payment-webhook-form';
import { EnableDisablePaymentWebhookForm } from '../../../../@shared/forms/setting/webhooks/payment/enable-disable-payment-webhook-form/enable-disable-payment-webhook-form';
import { TestPaymentWebhookForm } from '../../../../@shared/forms/setting/webhooks/payment/test-payment-webhook-form/test-payment-webhook-form';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-payment-webhook',
  imports: [TableModule, CardModule, TooltipModule, ButtonModule, AddPaymentWebhookForm, DeletePaymentWebhookForm, EnableDisablePaymentWebhookForm, TestPaymentWebhookForm],
  templateUrl: './payment-webhook.html',
  styleUrl: './payment-webhook.scss'
})
export class PaymentWebhookList implements OnInit {

  paymentWebhookList = signal<PaymentWebhook[]>([]);
  selectedPaymentWebhook: PaymentWebhook

  addPaymentWebhookDialog = false
  deletePaymentWebhookDialog = false
  enableDisablePaymentWebhookDialog = false
  testPaymentWebhookDialog = false

  private paymentWebhookService = inject(PaymentWebhookService)

  ngOnInit() {
    this.getPaymentWebhooks();
  }

  getPaymentWebhooks = () => {
    this.paymentWebhookService.getPaymentWebhooksList().subscribe({
      next: (response) => {
        this.paymentWebhookList.set(response.data);
      }
    })
  }

  openAddPaymentWebhookDialog = () => {
    this.addPaymentWebhookDialog = true
  }

  onPaymentWebhookAdded = () => {
    this.getPaymentWebhooks();
    this.addPaymentWebhookDialog = false
  }

  openDeletePaymentWebhookDialog = (selectedRow: PaymentWebhook) => {
    this.selectedPaymentWebhook = selectedRow
    this.deletePaymentWebhookDialog = true
  }

  onPaymentWebhookDeleted = () => {
    this.getPaymentWebhooks()
    this.deletePaymentWebhookDialog = false
  }

  openEnableDisablePaymentWebhookDialog = (selectedRow: PaymentWebhook) => {
    this.selectedPaymentWebhook = selectedRow
    this.enableDisablePaymentWebhookDialog = true
  }

  onPaymentWebhookStatusChanged = () => {
    this.getPaymentWebhooks()
    this.enableDisablePaymentWebhookDialog = false
  }

  openTestPaymentWebhookDialog = (selectedRow: PaymentWebhook) => {
    this.selectedPaymentWebhook = selectedRow
    this.testPaymentWebhookDialog = true
  }

  onPaymentWebhookTested = () => {
    this.getPaymentWebhooks()
    this.testPaymentWebhookDialog = false
  }
}
